export default "__VITE_ASSET__Ds$$82o5__"